jQuery(document).ready(function () {
  /* Custom CV upload */
  if ($(".spontaneous").length > 0) {
    $(".spontaneous_upload_result").click(function () {
      $(".spontaneous_upload_button").click();
    });

    $(".spontaneous_upload_icon").click(function () {
      $(".spontaneous_upload_button").click();
    });

    $(".spontaneous_upload_button").change(function () {
      $(".spontaneous_upload_result").val($(this).prop("files")[0].name);
    });
  }

  /* trigger deploy  */

  $(".spontaneous_trigger").click(function () {
    $(".spontaneous_form_container").toggle();
  });
  $(".menu_spontaneous").click(function (event) {
    event.preventDefault()
    $(".spontaneous_form_container").toggle();
  });
  
  /* Close form */
  $(".spontaneous_close").click(function () {
    $(".spontaneous_form_container").toggle();
    $("body").css("overflow", "auto");
  });

  /* error deploy  */

  var mutationObserver = new MutationObserver(function (mutations) {
    if (
      $(".wpcf7-response-output").html() ==
      "Vous avez atteint la limite de vos candidatures spontanée"
    ) {
      $(".spontaneous_form").hide();
      $(".wpcf7-response-output").hide();
      $(".spontaneous_error").show();
      $(".wpcf7-response-output").text("");
    } else if (
      $(".wpcf7-response-output").html() ==
      "Votre candidature a bien été envoyée"
    ) {
      $(".spontaneous_form").hide();
      $(".wpcf7-response-output").hide();
      $(".spontaneous_succes").show();
      $(".wpcf7-response-output").text("");
    }


    if ($(".cardsautoplace").hasClass("aos-animate")) {
      document.querySelectorAll(".number-animate").forEach((el) => {
        const endValue = el.getAttribute("data-end-value");
        const incrementValue = el.getAttribute("data-increment");
        const durationValue = el.getAttribute("data-duration");
  
        if (endValue)
          numberAnimation(el, endValue, incrementValue, durationValue);
      });
      function numberAnimation(el, endValue, incrementor, duration) {
        anime({
          targets: el,
          textContent: endValue,
          round: incrementor ? 1 / incrementor : 1 / 2,
          easing: "easeInOutQuad",
          duration: duration ? duration : 4000,
        });
      }
    }
  });


  $(".wpcf7-spinner").html("Veuillez patienter<span class='dot'></span><span class='dot'></span><span class='dot'></span>");

  mutationObserver.observe(document.documentElement, {
    subtree: true,
    attributeOldValue: true,
    characterDataOldValue: true,
  });
});
